export default [
  {
    component: "TitleText",
    data: {
      title: 'chapter-3.slice-1.title',
      text: 'chapter-3.slice-1.description',
    }
  },
  {
    component: "VerticalGallery",
    data: {
      images: [
        {
          alt: "chapter-3.slice-1.image-1.alt",
          src: "chapter-3.slice-1.image-1.src",
          // src: require('@/assets/images/chapter-3_slice-1_image-1.jpg'),
          offset: -5.25,
          width: 63,
          speed: 0.5,
          ratio: 1008/671,
        },
        {
          alt: "chapter-3.slice-1.image-2.alt",
          src: "chapter-3.slice-1.image-2.src",
          // src: require('@/assets/images/chapter-3_slice-1_image-2.jpg'),
          offset: -5.25,
          width: 68.81,
          speed: 1,
          ratio: 1102/734,
        },
        {
          alt: "chapter-3.slice-1.image-3.alt",
          src: "chapter-3.slice-1.image-3.src",
          // src: require('@/assets/images/chapter-3_slice-1_image-3.jpg'),
          offset: -2.25,
          width: 63,
          speed: 0.5,
          ratio: 1009/671,
        },
        {
          alt: "chapter-3.slice-1.image-4.alt",
          src: "chapter-3.slice-1.image-4.src",
          // src: require('@/assets/images/chapter-3_slice-1_image-4.jpg'),
          offset: -5.125,
          width: 80.43,
          speed: -0.5,
          ratio: 1288/857,
        }
      ]  
    }
  },
  {
    component: "CarouselFull",
    data: {
      title: "chapter-3.slice-2.title",
      description: "chapter-3.slice-2.description",
      carousel: [
        {
          image: {
            alt: "chapter-3.slice-2.image-1.alt",
            src: "chapter-3.slice-2.image-1.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-1.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-2.alt",
            src: "chapter-3.slice-2.image-2.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-2.jpg')
          },
        }, {
          image: {
            alt: "chapter-3.slice-2.image-3.alt",
            src: "chapter-3.slice-2.image-3.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-3.jpg')
          },
        }, {
          image: {
            alt: "chapter-3.slice-2.image-4.alt",
            src: "chapter-3.slice-2.image-4.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-4.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-5.alt",
            src: "chapter-3.slice-2.image-5.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-5.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-6.alt",
            src: "chapter-3.slice-2.image-6.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-6.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-7.alt",
            src: "chapter-3.slice-2.image-7.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-7.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-8.alt",
            src: "chapter-3.slice-2.image-8.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-8.jpg')
          }
        }, {
          image: {
            alt: "chapter-3.slice-2.image-9.alt",
            src: "chapter-3.slice-2.image-9.src",
            // src: require('@/assets/images/chapter-3_slice-2_image-9.jpg')
          }
        },
        // {
        //   image: {
        //     alt: "chapter-3.slice-2.image-10.alt",
        //     src: "chapter-3.slice-2.image-10.src",
        //     // src: require('@/assets/images/chapter-3_slice-2_image-10.jpg')
        //   }
        // }
      ]
    }
  },
  {
    component: "TitleImage",
    data: {
      // debug: true,
      title: "chapter-3.slice-3.title",
      description: "chapter-3.slice-3.description",
      image: {
        alt: "chapter-3.slice-3.image.alt",
        src: "chapter-3.slice-3.image.src",
        // src: require('@/assets/images/chapter-3_slice-3_image-1.jpg')
      }
    }
  },
  {
    component: "CarouselFull",
    data: {
      // debug: true,
      title: "chapter-3.slice-4.title",
      description: "chapter-3.slice-4.description",
      carousel: [
        {
          image: {
            alt: "chapter-3.slice-4.image-1.alt",
            src: "chapter-3.slice-4.image-1.src",
            // src: require('@/assets/images/chapter-3_slice-4_image-1.jpg')
          },
          subtitle: "chapter-3.slice-4.image-1.title",
          description: "chapter-3.slice-4.image-1.description",
          quote: "chapter-3.slice-4.image-1.quote",
          author: "chapter-3.slice-4.image-1.author"
        }, {
          image: {
            alt: "chapter-3.slice-4.image-2.alt",
            src: "chapter-3.slice-4.image-2.src",
            // src: require('@/assets/images/chapter-3_slice-4_image-2.jpg')
          },
          subtitle: "chapter-3.slice-4.image-2.title",
          description: "chapter-3.slice-4.image-2.description",
          quote: "chapter-3.slice-4.image-2.quote",
          author: "chapter-3.slice-4.image-2.author"
        }, {
          image: {
            alt: "chapter-3.slice-4.image-3.alt",
            src: "chapter-3.slice-4.image-3.src",
            // src: require('@/assets/images/chapter-3_slice-4_image-3.jpg')
          },
          subtitle: "chapter-3.slice-4.image-3.title",
          description: "chapter-3.slice-4.image-3.description",
          quote: "chapter-3.slice-4.image-3.quote",
          author: "chapter-3.slice-4.image-3.author"
        }, {
          image: {
            alt: "chapter-3.slice-4.image-4.alt",
            src: "chapter-3.slice-4.image-4.src",
            // src: require('@/assets/images/chapter-3_slice-4_image-4.jpg')
          },
          subtitle: "chapter-3.slice-4.image-4.title",
          description: "chapter-3.slice-4.image-4.description",
          quote: "chapter-3.slice-4.image-4.quote",
          author: "chapter-3.slice-4.image-4.author"
        }, {
          image: {
            alt: "chapter-3.slice-4.image-5.alt",
            src: "chapter-3.slice-4.image-5.src",
            // src: require('@/assets/images/chapter-3_slice-4_image-5.jpg')
          },
          subtitle: "chapter-3.slice-4.image-5.title",
          description: "chapter-3.slice-4.image-5.description",
          quote: "chapter-3.slice-4.image-5.quote",
          author: "chapter-3.slice-4.image-5.author"
        }
      ]
    }
  },
  {
    component: "NextChapter",
    data: {
      image: {
        alt: "chapter-3.next.image.alt",
        src: "chapter-3.next.image.src",
        // src: require('@/assets/images/chapter-3_next.jpg')
      },
      nextChapter: "chapter-3.next.title"
    }
  }
]